import React, { useEffect, useState } from 'react';
import MainSlideCard from '../../cards/MainSlideCard';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from 'react-redux';
import { getMainSlider } from '../../../services/actions/MainAction';
import { ChevronLeft, ChevronRight, Zap, Shield, Clock, Award } from 'lucide-react';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1
  }
};

function MainSection() {
  const dispatch = useDispatch();
  const lang_id = useSelector(state => state.Data.lang_id);
  const mainSlider = useSelector(state => state.Data.mainSlider);
  const contentData = useSelector(state => state.Data.contentData);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    dispatch(getMainSlider(lang_id));
  }, [lang_id]);

  const CustomLeftArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white hover:scale-110 transition-all duration-300 group"
      aria-label="Əvvəlki slayd"
    >
      <ChevronLeft className="w-6 h-6 text-blue-600 group-hover:text-yellow-500 transition-colors" />
    </button>
  );

  const CustomRightArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white hover:scale-110 transition-all duration-300 group"
      aria-label="Növbəti slayd"
    >
      <ChevronRight className="w-6 h-6 text-blue-600 group-hover:text-yellow-500 transition-colors" />
    </button>
  );

  const CustomDot = ({ onClick, active }) => (
    <button
      onClick={onClick}
      className={`w-3 h-3 mx-1 rounded-full transition-all duration-300 ${active 
        ? 'w-8 bg-gradient-to-r from-yellow-400 to-yellow-500 shadow-lg' 
        : 'bg-gray-300 hover:bg-gray-400'
      }`}
      aria-label={`Slayd ${currentSlide + 1}`}
    />
  );

  const serviceFeatures = [
    { icon: <Zap className="w-6 h-6" />, title: contentData?.f1_title, desc: contentData?.f1_desc },
    { icon: <Shield className="w-6 h-6" />, title:  contentData?.f2_title, desc: contentData?.f2_desc },
    { icon: <Clock className="w-6 h-6" />, title: contentData?.f3_title, desc: contentData?.f3_desc },
    { icon: <Award className="w-6 h-6" />, title: contentData?.f4_title, desc: contentData?.f4_desc  }
  ];

  return (
    <div className="relative">
     

      <div className="relative z-10">
        {/* Service Features Banner - Above Slider */}
       

        {/* Main Slider */}
        <div className="relative mt-[20px]  overflow-hidden  mx-4 md:mx-8">

          <Carousel
            swipeable={true}
            draggable={true}
            showDots={true}
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={5000}
            keyBoardControl={true}
            customTransition="transform 1000ms ease-in-out"
            transitionDuration={1000}
            containerClass="h-full"
            dotListClass="custom-dot-list-style bottom-6"
            itemClass="h-full"
            customLeftArrow={<CustomLeftArrow />}
            customRightArrow={<CustomRightArrow />}
            customDot={<CustomDot />}
            beforeChange={(nextSlide) => setCurrentSlide(nextSlide)}
          >
            {mainSlider?.length > 0 ? (
              mainSlider.map((data, i) => (
                <MainSlideCard key={i} data={data} />
              ))
            ) : (
              // Fallback placeholder slides when no data
              [1, 2, 3].map((num) => (
                <div key={num} className="relative h-full">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800"></div>
                  <div className="absolute inset-0 flex items-center">
                    <div className="container mx-auto px-8 md:px-16">
                      <div className="max-w-2xl">
                        <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-yellow-400 to-yellow-500 text-white px-4 py-2 rounded-full mb-6">
                          <Zap className="w-5 h-5" />
                          <span className="font-bold">Professional Elektrik Xidmətləri</span>
                        </div>
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
                          {num === 1 && "Etibarlı Elektrik Həlləri"}
                          {num === 2 && "Peşəkar Elektrik Quraşdırılması"}
                          {num === 3 && "24/7 Elektrik Təmiri"}
                        </h1>
                        <p className="text-xl text-blue-100 mb-8 max-w-xl">
                          {num === 1 && "Ev və ofis elektrik sistemlərinin quraşdırılması, təmiri və texniki xidməti"}
                          {num === 2 && "Hər növ elektrik işləri üçün sertifikatlı mütəxəssislər"}
                          {num === 3 && "Qəza vəziyyətində sürətli və peşəkar təmir xidməti"}
                        </p>
                        <div className="flex flex-wrap gap-4">
                          <button className="px-8 py-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-white font-bold rounded-xl hover:from-yellow-500 hover:to-yellow-600 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                            Pulsuz Konsultasiya
                          </button>
                          <button className="px-8 py-4 bg-white/20 backdrop-blur-sm text-white font-bold rounded-xl border-2 border-white/30 hover:bg-white/30 transition-all duration-300">
                            051 123 45 67
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </Carousel>

          {/* Current Slide Indicator */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-30">
            <div className="bg-black/30 backdrop-blur-sm rounded-full px-4 py-2">
              <span className="text-white font-medium text-sm">
                {currentSlide + 1} / {mainSlider?.length || 3}
              </span>
            </div>
          </div>

          {/* Emergency Call Button - Floating */}
     
        </div>

        {/* Bottom Info Section */}
         <div className="container mx-auto px-4 py-6">
          <div className="grid grid-cols-4 max-[1050px]:grid-cols-3 max-[800px]:grid-cols-2 max-[550px]:grid-cols-1 gap-4 mb-8">
            {serviceFeatures.map((feature, index) => (
              <div 
                key={index} 
                className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-4 shadow-lg border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group"
              >
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 min-w-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center group-hover:from-blue-600 group-hover:to-blue-700 transition-all">
                    <div className="text-white">
                      {feature.icon}
                    </div>
                  </div>
                  <div>
                    <div className="font-bold text-gray-800 text-sm md:text-base group-hover:text-blue-700 transition-colors">
                      {feature.title}
                    </div>
                    <div className="text-gray-600 text-xs md:text-sm">
                      {feature.desc}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Custom Styles */}
      <style jsx>{`
        .custom-dot-list-style {
          position: absolute;
          bottom: 20px;
          display: flex;
          justify-content: center;
          width: 100%;
        }
        
        .react-multi-carousel-dot button {
          border: none;
          background: rgba(255, 255, 255, 0.5);
        }
        
        .react-multi-carousel-dot--active button {
          background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
          box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4);
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        .floating-element {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}

// Add Phone icon component if not available
const Phone = ({ className = "w-6 h-6" }) => (
  <svg 
    className={className} 
    fill="none" 
    stroke="currentColor" 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      strokeWidth={2} 
      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" 
    />
  </svg>
);

export default MainSection;